class Header {
	stateClasses = {
		active: 'active',
		hidden: 'hidden',
		menuOpen: 'menu--open',
	};

	constructor($el) {
		this.$el = $el;
		this.$html = $('html');
		this.$navItems = this.$el.find('[data-header="nav-item"]');
		this.$menuButton = this.$el.find('[data-header="menu-button"]');
		this.$mobileMenu = this.$el.find('[data-header="mobile-menu"]');
		this.scrollY = 0;
		this.scrollFrame = 0;
		this.isMenuOpen = false;
		this.isLocked = false;
		this.init();
	}

	init = () => {
		this.bindEvents();
	};

	bindEvents = () => {
		// Pro Frame höchstens einmal auswerten, passive für flüssiges Scrollen
		document.addEventListener('scroll', this.onScrollEvent, { passive: true });

		this.$menuButton.on('click', this.onMenuClick);
		document.addEventListener('keydown', this.onKeyDown);
	};

	onScrollEvent = () => {
		if (this.scrollFrame) return;
		this.scrollFrame = requestAnimationFrame(() => {
			this.scrollFrame = 0;
			this.onScroll();
		});
	};

	onScroll = () => {
		const newScrollY = Math.max(window.scrollY, 0);

		// Kleine Bewegungen ignorieren (z. B. Zittern beim Touch-Scrollen)
		if (Math.abs(newScrollY - this.scrollY) < 5) return;

		if (newScrollY > this.scrollY) {
			// hide header on scroll down
			if (this.canHide()) {
				this.hideHeader();
			}
		} else if (newScrollY < this.scrollY && !this.isLocked) {
			// show header on scroll up, ausser er ist gelockt (z. B. durch AnchorNav)
			this.showHeader();
		}

		this.scrollY = newScrollY;
	};

	/** Darf sich der Header auf dieser Seite beim Runterscrollen verstecken? */
	canHide = () => !this.$html.hasClass('home') || this.$html.hasClass('black');

	/** Header versteckt halten, auch beim Hochscrollen */
	lock = () => {
		if (!this.canHide()) return;
		this.isLocked = true;
		this.hideHeader();
	};

	/** Lock aufheben; der Header erscheint beim nächsten Hochscrollen wieder */
	unlock = () => {
		this.isLocked = false;
	};

	setActiveNavItem(sectionId) {
		const { active } = this.stateClasses;
		this.$navItems.removeClass(active).removeAttr('aria-current');
		this.$navItems
			.filter((index, item) => $(item).data('section-id') === sectionId)
			.addClass(active)
			.attr('aria-current', 'page');
	}

	onMenuClick = () => {
		if (this.isMenuOpen) {
			this.closeMenu();
		} else {
			this.openMenu();
		}
	};

	onKeyDown = e => {
		if (e.key === 'Escape' && this.isMenuOpen) {
			this.closeMenu();
			this.$menuButton.trigger('focus');
		}
	};

	/** Inhalt hinter dem offenen Menü für Tastatur und Screenreader sperren */
	setPageInert = inert => {
		$('[data-barba="container"], .footer').prop('inert', inert);
	};

	openMenu = () => {
		this.$html.addClass(this.stateClasses.menuOpen);
		this.$menuButton.attr('aria-expanded', 'true');
		this.$mobileMenu.prop('inert', false);
		this.setPageInert(true);
		this.isMenuOpen = true;

		// Fokus auf den ersten Menüpunkt
		this.$mobileMenu.find('a').first().trigger('focus');
	};

	closeMenu = () => {
		this.$html.removeClass(this.stateClasses.menuOpen);
		this.$menuButton.attr('aria-expanded', 'false');
		this.$mobileMenu.prop('inert', true);
		this.setPageInert(false);
		this.isMenuOpen = false;
	};

	hideHeader = () => {
		this.$el.addClass(this.stateClasses.hidden);
		this.$html.addClass('header-hidden');
	};

	showHeader = () => {
		this.$el.removeClass(this.stateClasses.hidden);
		this.$html.removeClass('header-hidden');
	};

	removeOpacity0 = () => {
		this.$el.removeClass('opacity-0');
	};

	addOpacity0 = () => {
		this.$el.addClass('opacity-0');
	};
}

export default new Header($('[data-header="el"]'));